import { render, staticRenderFns } from "./LaufTabelle.vue?vue&type=template&id=3009f960&scoped=true"
import script from "./LaufTabelle.vue?vue&type=script&lang=js"
export * from "./LaufTabelle.vue?vue&type=script&lang=js"
import style0 from "./LaufTabelle.vue?vue&type=style&index=0&id=3009f960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3009f960",
  null
  
)

export default component.exports